// extracted by mini-css-extract-plugin
module.exports = {"functions":"DingBeautyFunctions_functions_sbGbP"};